import { Fragment } from "react";
import { useThemeStore } from "../../stores/themeStore";
import WriteEssay from "../../../Essay/pages/Writing";

export default function EssayWrite() {
  const { theme } = useThemeStore();

  return (
    <Fragment>
      <WriteEssay key={theme?.slug} origin="course" slug={theme?.slug} />
    </Fragment>
  )
}
